/* MBG Compare Steps — pagination dots for the mobile card carousel and the desktop
   slider: from tablet up the cards scroll in one row and the arrows show up only
   while they overflow the container. Loaded only when the section renders more than
   one card. */
(function () {
    var ROOT_SELECTOR = '[data-mbg-cs]';
    var ACTIVE_CLASS = 'mbg-compare-steps__slider--active';
    var TOLERANCE = 2;

    function reducedMotion() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function initDots(scroller, dots) {
        var cards = Array.prototype.slice.call(scroller.children);
        if (dots.length < 2 || cards.length !== dots.length) return;

        function activate(index) {
            for (var i = 0; i < dots.length; i++) {
                dots[i].setAttribute('aria-current', i === index ? 'true' : 'false');
            }
        }

        function scrollToCard(event) {
            var index = Array.prototype.indexOf.call(dots, event.currentTarget);

            /* offsetLeft of both cards is measured from the same offset parent,
               so the difference is the exact scroll distance. */
            scroller.scrollTo({
                left: cards[index].offsetLeft - cards[0].offsetLeft,
                behavior: reducedMotion() ? 'auto' : 'smooth'
            });
        }

        for (var i = 0; i < dots.length; i++) {
            dots[i].addEventListener('click', scrollToCard);
        }

        /* IntersectionObserver instead of a scroll listener — no work between snap points. */
        if (!('IntersectionObserver' in window)) return;

        var observer = new IntersectionObserver(
            function (entries) {
                for (var i = 0; i < entries.length; i++) {
                    if (entries[i].isIntersecting) {
                        activate(cards.indexOf(entries[i].target));
                    }
                }
            },
            { root: scroller, threshold: 0.6 }
        );

        for (var c = 0; c < cards.length; c++) {
            observer.observe(cards[c]);
        }
    }

    /* The arrows are styled from 768px up only, so the class is safe to toggle
       on the mobile scroller as well. */
    function initSlider(slider, scroller) {
        var prev = slider.querySelector('[data-mbg-cs-prev]');
        var next = slider.querySelector('[data-mbg-cs-next]');

        if (!prev || !next) return;

        function sync() {
            var active = scroller.scrollWidth - scroller.clientWidth > TOLERANCE;

            if (active) {
                slider.classList.add(ACTIVE_CLASS);
            } else {
                slider.classList.remove(ACTIVE_CLASS);
                scroller.scrollLeft = 0;
            }

            prev.setAttribute('aria-hidden', active ? 'false' : 'true');
            next.setAttribute('aria-hidden', active ? 'false' : 'true');
            prev.tabIndex = active ? 0 : -1;
            next.tabIndex = active ? 0 : -1;
        }

        /* One card + one gap per click. */
        function step() {
            var card = scroller.firstElementChild;

            if (!card) return scroller.clientWidth;

            var gap = parseFloat(window.getComputedStyle(scroller).columnGap);

            return card.getBoundingClientRect().width + (isNaN(gap) ? 0 : gap);
        }

        /* Wraps around at both ends. */
        function scrollBySlide(direction) {
            var max = scroller.scrollWidth - scroller.clientWidth;

            if (max <= TOLERANCE) return;

            var target;

            if (direction > 0 && scroller.scrollLeft >= max - TOLERANCE) {
                target = 0;
            } else if (direction < 0 && scroller.scrollLeft <= TOLERANCE) {
                target = max;
            } else {
                target = scroller.scrollLeft + direction * step();
            }

            scroller.scrollTo({
                left: Math.max(0, Math.min(max, target)),
                behavior: reducedMotion() ? 'auto' : 'smooth'
            });
        }

        prev.addEventListener('click', function () {
            scrollBySlide(-1);
        });

        next.addEventListener('click', function () {
            scrollBySlide(1);
        });

        sync();

        if (window.ResizeObserver) {
            new ResizeObserver(sync).observe(scroller);
        } else {
            window.addEventListener('resize', sync);
        }
    }

    function init(root) {
        if (root.dataset.mbgCsReady === 'true') return;

        var scroller = root.querySelector('[data-mbg-cs-scroller]');
        if (!scroller) return;

        root.dataset.mbgCsReady = 'true';

        var slider = root.querySelector('[data-mbg-cs-slider]');
        if (slider) initSlider(slider, scroller);

        initDots(scroller, root.querySelectorAll('[data-mbg-cs-dot]'));
    }

    function initAll(scope) {
        var roots = (scope || document).querySelectorAll(ROOT_SELECTOR);
        for (var i = 0; i < roots.length; i++) {
            init(roots[i]);
        }
    }

    initAll();

    document.addEventListener('shopify:section:load', function (event) {
        initAll(event.target);
    });
})();
